/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('ItemList', require('./components/ItemList.vue').default);
Vue.component('ItemCreator', require('./components/ItemCreator').default);
Vue.component('ItemsTypeList', require('./components/ItemsTypeList').default);
Vue.component('HarpsView', require('./components/HarpsView.vue').default);
Vue.component('HarpsHistory', require('./components/HarpsHistory.vue').default);
Vue.component('HarpsWhere', require('./components/HarpsWhere.vue').default);
Vue.component('StringsLayoutsList', require('./components/strings-layout/StringsLayoutsList.vue').default);
Vue.component('StringLayout', require('./components/strings-layout/StringLayout.vue').default);
Vue.component('StringLayoutEditor', require('./components/strings-layout/StringLayoutEditor.vue').default);
Vue.component('Logo', require('./components/Logo.vue').default);
Vue.component('Dropdown', require('./components/Dropdown.vue').default);
Vue.component('StringLayoutRevision', require('./components/strings-layout/StringLayoutRevision.vue').default);
Vue.component('FixCreator', require('./components/FixCreator.vue').default);
Vue.component('Login', require('./components/Login.vue').default);
Vue.component('Logout', require('./components/Logout.vue').default);
Vue.component('Register', require('./components/Register.vue').default);
Vue.component('AdminWidget', require('./components/AdminWidget').default);
Vue.component('SubscriptionsManager', require('./components/SubscriptionsManager').default);
Vue.component('NotifyMe', require('./components/NotifyMe').default);
Vue.component('FlashMessage', require('./components/flash/flashMessage').default);
Vue.component('UserCreator', require('./components/UserCreator').default);
Vue.component('Reasons', require('./components/qms/Reasons').default);
Vue.component('PartNumbers', require('./components/PartNumbers').default);
Vue.component('AddAnomaly', require('./components/qms/AddAnomaly').default);
Vue.component('EditAnomaly', require('./components/qms/EditAnomaly').default);
Vue.component('ItemInput', require('./components/searchable/ItemInput').default);
Vue.component('ImagesManager', require('./components/utilities/ImagesManager').default);
Vue.component('AnomaliesList', require('./components/qms/AnomaliesList').default);
Vue.component('SearchableAnomaliesList', require('./components/qms/SearchableAnomaliesList').default);
Vue.component('WorkUnitCreator', require('./components/WorkUnitCreator').default);
Vue.component('WorkUnitList', require('./components/WorkUnitList').default);
Vue.component('EventsViewer', require('./components/tools/EventsViewer').default);
Vue.component('InstructionList', require('./components/InstructionList').default);
Vue.component('StringItems', require('./components/StringItems').default);
Vue.component('StringsLayoutTypeList', require('./components/StringsLayoutTypeList').default);
Vue.component('DealersList', require('./components/warranty/DealersList').default);
Vue.component('GoodsList', require('./components/warranty/GoodsList').default);

Vue.config.ignoredElements = ['trix-editor'];

import Lang from 'lang.js';

const default_locale = window.default_language;
const fallback_locale = window.fallback_locale;
const messages = window.messages;

Vue.prototype.trans = new Lang( { messages, locale: default_locale, fallback: fallback_locale } );

Vue.prototype.formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
});

new Vue({
    el: '#app',

    mounted() {
        if (window.App.signedIn) {
            window.Echo.private(`Aitems.User.${window.App.user.id}`)
                .notification((notification) => {
                    flash('Nuova Revisione Pubblicata!');
                });
        }
    }
});


